module.exports = __webpack_public_path__ + "img/autarky_content_bg.c264630c.png";